module.exports = __webpack_public_path__ + "img/leaderBg.39dc6291.jpg";